import { render, staticRenderFns } from "./itemGroup.vue?vue&type=template&id=41e84a50"
import script from "./itemGroup.vue?vue&type=script&lang=js"
export * from "./itemGroup.vue?vue&type=script&lang=js"
import style0 from "./itemGroup.vue?vue&type=style&index=0&id=41e84a50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports